import { CreateMixin } from "@pdfking/reactivity/preact"
import deserialize_filelist from "../files/make/deserialize_filelist"

export const FilenamesMixin = CreateMixin({
  computed: {
    filenames() {
      return deserialize_filelist(this.filelist)
    },
  },
  props: {
    filelist: null as string | null,
  },
})
